/* 🤖 this file was generated by svg-to-ts */
export var spxIconArrowUp01Sharp = {
    name: 'arrow_up_01_sharp',
    data: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.25 15.14L11.29 10.1C11.63 9.77 11.79 9.6 12 9.6C12.21 9.6 12.37 9.77 12.71 10.1L17.75 15.14\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>"
};
